<p-rating
  [stars]="to.stars"
  [cancel]="to.cancel"
  [disabled]="to.disabled"
  [formControl]="$any(formControl)"
  [formlyAttributes]="field"
  [readonly]="to.readonly"
  (onChange)="to.change && to.change(field, $event)"
></p-rating>
